import React from 'react';
import PropTypes from 'prop-types';


const ViewOnlyBar = ({ viewedUser }) => (
  <h2 style={{ textAlign:'center', margin: '0 auto', marginBottom: '20px', marginLeft: '120px' }}>
    {`Viewing as ${viewedUser.first_name} ${viewedUser.last_name} -- No changes saved `}
  </h2>
); 

ViewOnlyBar.propTypes = {
  viewedUser: PropTypes.shape({})
}


export default ViewOnlyBar
